import React from 'react';
import { connect } from 'react-redux';
import OptionGroups from '../MenuEditor/components/GlobalOptions/option-groups';
import MenuList from './components/MenuList';
import MenuEditorContextProvider from './contexts/use-menu-editor-context';

function MenuEditorContainer(props) {
  const { venue } = props;

  return (
    <MenuEditorContextProvider>
      <MenuList acceptPreorders={venue.accept_preorders} />
      <OptionGroups />
    </MenuEditorContextProvider>
  );
}

const mapStateToProps = state => ({
  venue: state.venue,
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuEditorContainer);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/index.jsx